import { Box, Button, Grid, Input, Modal, ModalBody, Text } from 'flexibull2'
import React, { useEffect, useState } from 'react'

import { Notify } from 'flexibull2/build/notify'
import { ERROR_ALERT, SUCCESS, TOP_RIGHT } from '../../../utils/constants'
import { AddNewPaylogConfig, UpdatePaylogConfig } from './services'

const AddPaylog = ({
    open,
    orgShortName,
    setOpen,
    isEdit,
    editData,
    callback,
}) => {
    const [values, setValues] = useState({
        paylog_id: editData?.paylog_id,
        schoolShortName: orgShortName,
        error: null,
    })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (editData) {
            setValues((prev) => {
                return { ...prev, paylog_id: editData.paylog_id }
            })
        }
    }, [editData])

    const submit = async () => {
        const { error, ...payload } = values

        const onSuccess = () => {
            setLoading(false)
            callback()
            Notify(
                `Paylog Configuration was ${
                    isEdit ? 'updated' : 'added'
                } successful`,
                {
                    position: TOP_RIGHT,
                    status: SUCCESS,
                }
            )
        }

        try {
            setLoading(true)

            if (!isEdit) {
                await AddNewPaylogConfig(payload)
                onSuccess()
            } else {
                await UpdatePaylogConfig({ ...payload, id: editData.id })
                onSuccess()
            }
        } catch (error) {
            Notify(
                `${
                    error.response.data?.errors?.[0]?.defaultMessage ??
                    'Unexpected Error'
                }`,
                {
                    position: TOP_RIGHT,
                    status: ERROR_ALERT,
                }
            )
            setLoading(false)
        }
    }
    const handleValues = (e) => {
        setValues({ ...values, [e.target.name]: e.target.value })
    }

    return (
        <div>
            <Modal outerClick open={open}>
                <ModalBody style={{ background: '#fff' }} width="550px">
                    <Box pad="20px 40px 0">
                        <Box
                            style={{
                                marginBottom: '2rem',
                            }}
                        >
                            <Text size="22px" block>
                                {isEdit ? 'Update' : 'Add'} Paylog
                            </Text>
                        </Box>
                        <Grid default="1fr">
                            <Box pad=" 0 0 0">
                                <Input
                                    label="Paylog ID"
                                    name="paylog_id"
                                    value={values.paylog_id}
                                    placeholder="Enter Paylog ID"
                                    spaceBottom="15px"
                                    block
                                    onChange={handleValues}
                                />
                            </Box>
                        </Grid>
                    </Box>
                    <Box pad="0px 30px 40px 0">
                        <Box align="right">
                            <Button
                                style={{
                                    border: 'none',
                                    textAling: 'center',
                                    color: '#000',
                                }}
                                width={90}
                                onClick={() => setOpen(false)}
                                pale
                                pad="0 20px"
                            >
                                Cancel
                            </Button>
                            <Button
                                width={120}
                                pad="0 15px"
                                spaceRight
                                onClick={submit}
                                iconRight={
                                    <i className="flexibull-angle-right" />
                                }
                                progress={loading}
                            >
                                Submit
                            </Button>
                        </Box>
                    </Box>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default AddPaylog
